import { Component, OnInit, OnDestroy } from '@angular/core';
import { CrudService } from '../../crud.service';
import { Subscription } from 'rxjs/Subscription';
@Component({
  selector: 'app-blank',
  templateUrl: './app-blank.component.html',
  styleUrls: ['./app-blank.component.css']
})
export class AppBlankComponent implements OnInit, OnDestroy {
  drivers = [];
  cars = [];
  public getItemSub: Subscription;
  sharedChartOptions: any = {
    responsive: true,
    // maintainAspectRatio: false,
    legend: {
      display: false,
      position: 'bottom'
    }
  };
  //barchart
  barChartLabels1: string[];
  barChartType = 'horizontalBar';
  barChartLegend = true;
  barChartData1: any[] = [{
    data: [],
    label: 'จำนวนครั้งในการให้บริการ',
    borderWidth: 0
  }/*, {
    data: [5, 4, 4, 3, 6, 2, 5],
    label: 'ภายนอกจังหวัด',
    borderWidth: 0
  }*/];
   //barchart
   barChartLabels2: string[];
   barChartData2: any[] = [{
     data: [],
     label: 'จำนวนครั้งในการให้บริการ',
     borderWidth: 0
   }];
  barChartOptions: any = Object.assign({
    scaleShowVerticalLines: false,
    scales: {
      xAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0.02)',
          zeroLineColor: 'rgba(0,0,0,0.02)'
        }
      }],
      yAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0.02)',
          zeroLineColor: 'rgba(0,0,0,0.02)'
        },
        position: 'left',
        ticks: {
          beginAtZero: true,
          suggestedMax: 9
        }
      }]
    }
  }, this.sharedChartOptions);
  barChartHorizontalType = 'horizontalBar';
  barChartHorizontalOptions: any = Object.assign({
    scaleShowVerticalLines: false,
    scales: {
      xAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0.02)',
          zeroLineColor: 'rgba(0,0,0,0.02)'
        },
        ticks: {
          beginAtZero: true,
          suggestedMax: 9
        }
      }],
      yAxes: [{
        gridLines: {
          color: 'rgba(0,0,0,0.02)',
          zeroLineColor: 'rgba(0,0,0,0.02)'
        }
      }]
    }
  }, this.sharedChartOptions);
  constructor(
    private crudService: CrudService,
  ) { }
  export_PDF(car_driver,driver_name) { 
    window.open('https://carbooking.snru.ac.th/back_end/PDF_car_work_report.php?car_driver='+car_driver+'&driver_name='+driver_name, '_blank');
  }
  ngOnInit() {
    this.get_drivers_data();
    this.get_cars_data();
    this.getItemSub = this.crudService.getDriverReport()
    .subscribe(data => { 
      const driver_name = [];
      const booking_num = [];    
        for (let i = 0; i < data.length; i++) {
          driver_name.push(data[i].barChartLabels);
          booking_num.push(parseInt(data[i].barChartData));
        }
        this.barChartLabels1 = driver_name;
        this.barChartData1[0].data = booking_num;
        //console.log(this.driver_name, this.barChartData[0].data)
    })
    this.getItemSub = this.crudService.getCarsReport()
    .subscribe(data => { 
      const driver_name = [];
      const booking_num = [];        
        for (let i = 0; i < data.length; i++) {
          driver_name.push(data[i].barChartLabels);
          booking_num.push(parseInt(data[i].barChartData));
        }
        this.barChartLabels2 = driver_name;
        this.barChartData2[0].data = booking_num;
        //console.log(this.driver_name, this.barChartData[0].data)
    })
  }
  get_drivers_data() {
    this.getItemSub = this.crudService.getCarDriver()
      .subscribe(data => {
        this.drivers = data;
      })
  }
  get_cars_data() {
    this.getItemSub = this.crudService.getCars()
      .subscribe(data => {
        this.cars = data;
      })
  }
  /*
* Bar Chart Event Handler
*/
  public barChartClicked(e: any): void {
  }
  public barChartHovered(e: any): void {
  }

  ngOnDestroy() {
    this.getItemSub.unsubscribe();

  }

}



// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/views/others/app-blank/app-blank.component.ts